import axios from '@/api/client';

const state = {
  transactions: null,
  transaction: null
};

const getters = {
  stateTransactions: state => state.transactions,
  stateTransaction: state => state.transaction,
};

function formToObject(form) {
  if (form instanceof FormData) {
    return Object.fromEntries(form.entries())
  }
  return { ...(form || {}) }
}

const actions = {
  async createTransaction({commit}, payload) {
    //await axios.post('transaction', transaction);
    //await dispatch('getTransactions');

    //console.log('--payload:',payload)
    const asString2 = new URLSearchParams(payload).toString();
    //console.log('--Post:',asString2)

    const url = 'transaction?'+asString2
    const {data} = await axios.post(url)

    commit('setTransaction', data);
    return data;
  },
  //liefert nur zu angemeldetem User
  async getTransactions({commit}, stockid) {
    console.log('getTransactions:',stockid)

    //let {data} = await axios.get(`transactions?stock_id=${stockid}`);
    if(stockid){
        let {data} = await axios.get(`transactions?stock_id=${stockid}`)
        commit('setTransactions', data);
        }
    else{
        let {data} = await axios.get(`transactions`)
        commit('setTransactions', data);
    }
    //let {data} = await axios.get('transactions?stock_id=163')
    //commit('setTransactions', data);
  },
  async getTransactionsOLD({commit}) {
    console.log('<-<-<-<-<>>>transactions.js: getTransactions:')
    let {data} = await axios.get('transactions');
    commit('setTransactions', data);
  },
  //liefert zu allen Usern
  async postTransactions({commit}) {
    let {data} = await axios.post('transactions');
    commit('setTransactions', data);
    },
  async setTransactions({commit}, id) {
    console.log('setTransaction:',id)

    let {data} = await axios.get(`transaction/${id}`);
    commit('setTransaction', data);
  },
  // eslint-disable-next-line no-empty-pattern
  async updateTransaction({}, transaction) {
    const source = formToObject(transaction?.form)

    const payload = {
      idstocks_transactions: Number(transaction?.id ?? source.idstocks_transactions ?? source.transaction_id ?? source.idtransactions ?? source.stocks_transactions_id ?? 0),
      stocks_transactions_category: Number(source.stocks_transactions_category ?? source.aenderungskennzeichen ?? 0),
      stocks_idstocks: Number(source.stocks_idstocks ?? source.idstocks ?? 0),
      stocks_user_iduser: Number(source.stocks_user_iduser ?? source.user_iduser ?? 0),
      stocks_menge: Number(source.stocks_menge ?? source.menge ?? 0),
      stocks_gebuehr: Number(source.stocks_gebuehr ?? source.gebuehr ?? 0),
      stocks_transactions_preisprostueck: Number(source.stocks_transactions_preisprostueck ?? source.preis ?? source.stocks_transactions_preis ?? 0),
      stocks_transactions_preis: Number(source.stocks_transactions_preis ?? source.preis ?? 0),
      stocks_transactions_preisV02: Number(source.stocks_transactions_preisV02 ?? source.preisV02 ?? 0),
      stocks_transactions_datum: source.stocks_transactions_datum ?? source.datum ?? '',
      stocks_transactions_beschreibung: source.stocks_transactions_beschreibung ?? source.beschreibung ?? '',
    }

    console.log('updateTransaction request:', payload)

    const { data } = await axios.post('updatetransaction', payload)
    return data
  },
  // eslint-disable-next-line no-empty-pattern
  async deleteTransaction({}, id) {
    await axios.delete(`transaction/${id}`);
  }
};

const mutations = {
  setTransactions(state, transactions){
    state.transactions = transactions;
  },
  setTransaction(state, transaction){
    state.transaction = transaction;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
